// src/components/Layout.js
import React from 'react';
import { Outlet } from 'react-router-dom';
import Toolbar from './Toolbar';

function Layout() {
  return (
    <>
      <Toolbar />
      <Outlet />
    </>
  );
}

export default Layout;